import { render } from "./Staff.vue?vue&type=template&id=ba0506fc"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"
script.render = render

export default script